export interface IDummyCrudSearchPub {
  id: string;
  name: string;
  description: string;
  price: number;
  fileUrl: string;
  fileName: string;
  isUrgent: boolean;
  statusName: string;
  dateExpired?: Date;

  isActive: boolean;
  dateCreated: Date;
  dateModified?: Date;
}

export class DummyCrudSearchPub implements IDummyCrudSearchPub {
  id: string;
  name: string;
  description: string;
  price: number;
  fileUrl: string;
  fileName: string;
  isUrgent: boolean;
  statusName: string;
  dateExpired?: Date;

  isActive: boolean;
  dateCreated: Date;
  dateModified?: Date;

  constructor();
  constructor(data: IDummyCrudSearchPub);
  constructor(data?: IDummyCrudSearchPub) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
    this.description = data?.description ?? '';
    this.price = data?.price ?? 0;
    this.fileUrl = data?.fileUrl ?? '';
    this.fileName = data?.fileName ?? '';
    this.isUrgent = data?.isUrgent ?? false;
    this.statusName = data?.statusName ?? '';
    this.dateExpired = data?.dateExpired;
    this.isActive = data?.isActive ?? true;
    this.dateCreated = data?.dateCreated ?? new Date();
    this.dateModified = data?.dateModified;
  }
}
